import { authenticatedLogger } from './authenticatedLogger';

class Logger {
  public info = async (message: string, context?: Record<string, unknown>): Promise<void> => {
    (await authenticatedLogger.getLogger()).info(message, context);
  };

  public error = async (message: string, context?: Record<string, unknown>): Promise<void> => {
    (await authenticatedLogger.getLogger()).error(message, context);
  };

  public debug = async (message: string, context?: Record<string, unknown>): Promise<void> => {
    (await authenticatedLogger.getLogger()).debug(message, context);
  };

  public warn = async (message: string, context?: Record<string, unknown>): Promise<void> => {
    (await authenticatedLogger.getLogger()).warn(message, context);
  };
}

export const logger = new Logger();
